import { useEffect, useRef } from 'react';

// Default refresh interval (seconds)
const DEFAULT_INTERVAL = 60;

function useAutoRefresh(refetch, options = {}) {
  const {
    interval = DEFAULT_INTERVAL,
    enabled = true,
  } = options;

  const refetchRef = useRef(refetch);
  refetchRef.current = refetch;

  const intervalMs = interval * 1000;

  useEffect(() => {
    if (!enabled) return () => {};

    const timerId = setInterval(() => {
      if (!document.hidden) {
        refetchRef.current();
      }
    }, intervalMs);

    return () => clearInterval(timerId);
  }, [intervalMs, enabled]);
}

export default useAutoRefresh;